import React, { Component } from "react";
import "./Contact.css";

class AboutMe extends Component {
	constructor(props) {
		super(props);
		this.state = { data: 0, scroll: 0 };
	}

	handleScroll1 = () => {
		let el = document.querySelector(".contactDiv");
		let elPosition = el.getBoundingClientRect();
		let screenPosition = window.innerHeight;
		if (window.matchMedia("(max-width: 360px)").matches) {
			this.setState({ scroll: 0 });
		}
		if (window.matchMedia("(max-width: 375px)").matches) {
			this.setState({ scroll: 0 });
		} else if (elPosition.top < screenPosition) {
			this.setState({ scroll: elPosition.y });
		}
	};

	componentDidMount() {
		window.addEventListener("scroll", this.handleScroll1);
	}

	render() {
		return (
			<article className='contact'>
				<h2 style={{ transform: `translateX(${-this.state.scroll * 0.0}px)` }}>
					Kontakt
				</h2>
				<div>
					<a
						href='https://www.tiktok.com/@motorschirm.pfalz?is_from_webapp=1&sender_device=pc'
						target='_blank'
						rel='noreferrer'>
						<img src='./img/contact/tiktok.png' alt='tiktok' s />
					</a>
					<a href='' target='_blank' rel='noreferrer'>
						<img src='./img/contact/instagram.png' alt='instagram' />
					</a>
					<a
						href='mailto:semir01020@gmail.com'
						target='_blank'
						rel='noreferrer'>
						<img src='./img/contact/at-solid.svg' alt='email' />
					</a>
				</div>
			</article>
		);
	}
}

export default AboutMe;
